import { render, staticRenderFns } from "./civilization.vue?vue&type=template&id=004ba394&"
import script from "./civilization.vue?vue&type=script&lang=js&"
export * from "./civilization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports